import * as React from 'react'
import { usePopoverContentData } from './hooks'

import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import { AppointmentsCard } from './AppointmentsCard'
import { AppointmentsPopoverProps } from './typing'
import { LoadingSpinner } from '@sales-center/components'
import { useDialogState } from '@user/utils/useDialogState'
import { AppointmentDialogWrapper } from './atoms'
import { useCallback, useState } from 'react'

export function AppointmentsPopoverContent(props: AppointmentsPopoverProps) {
  const { onClose, entityId, entityType } = props

  const [openDialog, onOpenDialog, onCloseDialog] = useDialogState()

  const [completeView, setCompleteView] = useState<boolean>(false)
  const onOpenNestedDialog = useCallback(
    (completeView: boolean) => {
      setCompleteView(completeView)
      onOpenDialog()
    },
    [onOpenDialog],
  )

  const { loading, error, newestAppointment, appointmentId } =
    usePopoverContentData(props)

  const showError = error || !newestAppointment

  return (
    <>
      <>
        {loading === 'pending' ? (
          <Box width="150px" height="150px">
            <LoadingSpinner />
          </Box>
        ) : showError ? (
          <Box p={1}>
            <Alert severity="error">Unable to load Appointments</Alert>
          </Box>
        ) : (
          <Box minWidth="520px">
            <AppointmentsCard
              onCloseMain={onClose}
              entityAppointment={newestAppointment}
              onOpenNestedDialog={onOpenNestedDialog}
            />
          </Box>
        )}
      </>

      <AppointmentDialogWrapper
        entityId={entityId}
        entityType={entityType}
        open={openDialog}
        onClose={onCloseDialog}
        onCloseMain={onClose}
        appointmentId={appointmentId}
        completeView={completeView}
      />
    </>
  )
}
